import type {IUserPreferences} from "../interfaces/IUserPreferences";

export const transformUserPreferencesForSave = (preferences: IUserPreferences & {construction_end_date?: string | string[]}): IUserPreferences => {
    if (preferences.filters) {
        const {construction_end_date: constructionEndDate, floor_choices: floorChoices} = preferences.filters;

        const userPreferencesToSave = {filters: {...preferences.filters}};

        if (constructionEndDate) {
            userPreferencesToSave.filters.construction_end_date = Array.isArray(constructionEndDate) ? constructionEndDate[0] : constructionEndDate;
        }

        if (floorChoices) {
            userPreferencesToSave.filters.floor_choices = Array.isArray(floorChoices) ? floorChoices : [floorChoices];
        }

        return userPreferencesToSave;
    }

    return {
        filters: {}
    };
};
import type {IUserPreferences} from "../interfaces/IUserPreferences";

export const transformUserPreferencesForSave = (preferences: IUserPreferences & {construction_end_date?: string | string[]}): IUserPreferences => {
    if (preferences.filters) {
        const {construction_end_date: constructionEndDate, floor_choices: floorChoices} = preferences.filters;

        const userPreferencesToSave = {filters: {...preferences.filters}};

        if (constructionEndDate) {
            userPreferencesToSave.filters.construction_end_date = Array.isArray(constructionEndDate) ? constructionEndDate[0] : constructionEndDate;
        }

        if (floorChoices) {
            userPreferencesToSave.filters.floor_choices = Array.isArray(floorChoices) ? floorChoices : [floorChoices];
        }

        return userPreferencesToSave;
    }

    return {
        filters: {}
    };
};
